// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1f1c65a","239":"75367b6d","732":"758ff4b2"}[chunkId] + ".chunk.js";
};